module.exports = __webpack_public_path__ + "img/ben_story.71549f21.svg";